import script from "./RatingBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./RatingBlock.vue?vue&type=script&setup=true&lang=js"

import "./RatingBlock.vue?vue&type=style&index=0&id=7cecc716&lang=scss"

const __exports__ = script;

export default __exports__